import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="max-w-3xl mx-auto px-6 pt-12 pb-8" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="space-y-6" data-id="element-58">
        <div className="space-y-4 text-center sm:text-left" data-id="element-59">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-brand-brown leading-tight" data-id="element-60">
            Mein Hund hatte ständig Sodbrennen – bis ich das hier entdeckt habe
          </h1>
          <p className="text-lg sm:text-xl text-stone-600 font-serif leading-relaxed" data-id="element-61">
            Eine Geschichte über nächtliches Würgen, hilflose Tierarztbesuche
            und die Lösung, die alles verändert hat.
          </p>
          <div className="flex items-center justify-center sm:justify-start gap-3 pt-2" data-id="element-62">
            <div className="w-10 h-10 rounded-full bg-stone-200 overflow-hidden" data-id="element-63">
              <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&q=80" alt="Lisa" className="w-full h-full object-cover" data-id="element-64" />
            </div>
            <div className="text-sm font-sans text-stone-500" data-id="element-65">
              <span className="font-medium text-stone-700" data-id="element-66">Von Lisa & Max</span>
              <span className="mx-2" data-id="element-67">·</span>
              <span data-id="element-68">12. März 2025</span>
            </div>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] sm:aspect-[16/9] mt-8" data-id="element-69">
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=1200&q=80" alt="Hund schaut nachdenklich" className="w-full h-full object-cover" data-id="element-70" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-71"></div>
        </div>
      </motion.div>
    </section>;
}